import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const edongBoHocPhiActionsObj = {
  LOAD_START: {} as IDongBoHocPhiRequest,
  LOAD_SUCCESS: {} as IDongBoHocPhiSinhVien[],
  LOAD_ERRR: {} as string,

  SHOW_HIDE_VIEW_LOP_TIN_CHI: {} as string,

  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  SYNC_START: {} as IProcessRequest<IDongBoHocPhiRequest>,
  SYNC_SUCCESS: {} as IDongBoHocPhiSinhVien[],
  SYNC_ERR: {} as string,

  CHANGE_REQUEST: {} as any,

  CLOSE_PROCESSING_MODAL: undefined,
};

export const eDongBoHocPhiActionTypeIds = generateActionTypeIds(
  edongBoHocPhiActionsObj,
  "DONG_BO_HOC_PHI",
);
export type IDongBoHocPhiActionTypes = IGenericActionType<
  typeof edongBoHocPhiActionsObj,
  "DONG_BO_HOC_PHI"
>;
